export default __webpack_public_path__ + "images/0125d439a81e4f2766293f63630a72ae-ballet.jpg";